/* eslint-disable banhammer/no-restricted-functions */

import { Consent, consented } from './consent'

export const setLocalStorageItem = (
  itemKey: string,
  itemValue: any,
  consentType: Consent
) => {
  if (consented(consentType)) {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(itemKey, JSON.stringify(itemValue))
      }
    } catch (error) {}
  }
}

export const getLocalStorageItem = (
  itemKey: string,
  consentType: Consent,
  defaultValue: any = null
) => {
  let result: any

  if (consented(consentType)) {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        const value = window.localStorage.getItem(itemKey)
        if (value) {
          try {
            result = JSON.parse(value)
          } catch (error) {
            result = value
          }

          return result == null ? defaultValue : result
        }
      }
    } catch (error) {}
  }

  return defaultValue
}
